import { useState, useEffect, useContext } from "react";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import axios from "axios";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export default function LeadForm({
  leadId,
  updatedFormData,
  setIsFormUpdated,
  onClose,
  onSuccess,
  setOpenForm = null,
  closeModal,
}) {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [labels, setLabels] = useState([]);
  const [errors, setErrors] = useState({
    email: "",
    phone: "",
    otherContactNo: "",
  });
  const [touched, setTouched] = useState({
    email: false,
    phone: false,
    otherContactNo: false,
  });
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    otherContactNo: "",
    companyName: "",
    companyId: "",
    leadDate: "",
    reference: "",
    address: "",
    city: "",
    state: "",
    comment: "",
    updatedAt: new Date().toISOString(),
    sourceName: "",
    statusName: "",
    statusColor: "",
    projectName: "",
    projectNameColor: "",
    reason: "",
    assignedToId: "",
    assignedToName: "",
    createdById: "",
    createdByName: "",
  });

  // Update form data when `updatedFormData` changes
  useEffect(() => {
    if (updatedFormData) {
      setFormData((prevData) => ({
        ...prevData,
        ...updatedFormData,
      }));
    }
  }, [updatedFormData]);
  // staet Section
  useEffect(() => {
    async function fetchStates() {
      try {
        const res = await fetch(`${API_URL}/api/india/states`);
        const data = await res.json();
        if (Array.isArray(data.data)) {
          setStateList(data.data); // DIRECTLY SET — NO FILTER, NO SORT
        }
      } catch (err) {
        console.error("Error fetching states:", err);
      }
    }
    fetchStates();
  }, []);

  //  city seection
  useEffect(() => {
    async function fetchCities() {
      if (!formData.state) {
        setCityList([]);
        return;
      }
      // IMPORTANT: reset city when state changes
      setFormData((prev) => ({ ...prev, city: "" }));
      try {
        const res = await fetch(
          `${API_URL}/api/india/cities?state=${formData.state}`
        );
        const data = await res.json();
        if (Array.isArray(data.data)) {
          setCityList(data.data);
        } else {
          setCityList([]);
        }
      } catch (err) {
        console.error("Error fetching cities:", err);
      }
    }

    fetchCities();
  }, [formData.state]);

  // Set companyId when user changes
  useEffect(() => {
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
      }));
    }
  }, [user]);

  // Set createdById and createdByName when user is available
  useEffect(() => {
    if (user?.id && user?.name) {
      setFormData((prevData) => ({
        ...prevData,
        createdById: user.id,
        createdByName: user.name,
      }));
    }
  }, [user]);

  // Fetch users when component mounts
  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      try {
        const response = await fetch(
          `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`,
          {
            method: "GET",
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  // Fetch Status and Source from backend
  useEffect(() => {
    async function fetchStatusAndSource() {
      if (!user) return;
      const companyId =
        user.accountType === "COMPANY" ? user.id : user.companyId;
      try {
        const [statusRes, sourceRes] = await Promise.all([
          axios.get(`${API_URL}/api/leadStatus/company/${companyId}`, {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }),
          axios.get(`${API_URL}/api/leadSource/company/${companyId}`, {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }),
        ]);

        setStatusOptions(statusRes.data || []);
        setSourceOptions(sourceRes.data || []);
      } catch (error) {
        console.error("Error fetching status/source:", error);
      }
    }
    fetchStatusAndSource();
  }, [user]);

  const validateEmail = (email) => {
    // Add null/undefined check
    if (!email) return ""; // Return empty string if email is null/undefined

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email) && email.length > 0) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const validatePhone = (phone) => {
    const numericRegex = /^[0-9]*$/;
    if (!numericRegex.test(phone)) {
      return "Only numbers are allowed";
    }
    if (phone.length > 13) {
      return "Phone number cannot exceed 13 digits";
    }
    return "";
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched({ ...touched, [name]: true });

    if (name === "email") {
      setErrors({ ...errors, email: validateEmail(value) });
    } else if (name === "phone" || name === "otherContactNo") {
      setErrors({ ...errors, [name]: validatePhone(value) });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Updated regex patterns:
    const unicodeLettersRegex = /^[\p{L}\p{M}\s]*$/u; // Allows any Unicode letters (including Hindi)
    const numericRegex = /^[0-9]*$/;

    switch (name) {
      case "name":
        if (value.length > 25 || !unicodeLettersRegex.test(value)) return;
        break;
      case "reference":
      case "companyName":
        if (value.length > 50 || !unicodeLettersRegex.test(value)) return;
        break;
      case "phone":
      case "otherContactNo":
        if (value.length > 13 || !numericRegex.test(value)) return;
        setErrors({ ...errors, [name]: validatePhone(value) });
        break;
      case "email":
        if (value.length > 100) return;
        setErrors({ ...errors, email: validateEmail(value) });
        break;
      default:
        break;
    }

    if (name === "assignedToId") {
      const selectedUser = users.find((user) => user.id === value);
      setFormData((prevData) => ({
        ...prevData,
        assignedToId: value,
        assignedToName: selectedUser
          ? `${selectedUser.fname} ${selectedUser.lname}`
          : "",
      }));
    } else if (name === "statusName") {
      const selectedStatus = statusOptions.find(
        (status) => status.name === value
      );
      setFormData((prevData) => ({
        ...prevData,
        statusName: selectedStatus?.name || "",
        statusColor: selectedStatus?.color || "",
      }));
    } else if (name === "sourceName") {
      const selectedSource = sourceOptions.find(
        (source) => source.name === value
      );
      setFormData((prevData) => ({
        ...prevData,
        sourceName: selectedSource?.name || "",
      }));
    } else if (name === "projectName") {
      const selectedProject = labels.find((label) => label.name === value);
      setFormData((prevData) => ({
        ...prevData,
        projectName: selectedProject?.name || "",
        projectNameColor: selectedProject?.color || "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleCreateLead = async () => {
    try {
      const response = await fetch(`${API_URL}/api/leads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      toast.success(result.message); // Show success message
      onSuccess(); // callback to reload data in parent
      onClose();
      setIsFormVisible(false);
    } catch (error) {
      console.error("Error creating lead:", error);
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleUpdateLead = async () => {
    if (!leadId) {
      console.error("Lead ID is missing, cannot update.");
      return;
    }
    try {
      const response = await axios.put(
        `${API_URL}/api/leads/update/${leadId}/changedBy/${user?.id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success(response.data.message);
      setIsFormVisible(false);
      setIsFormUpdated(true);
      closeModal();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error updating lead:", error);
      toast.error(error.response?.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate email before submission
    const emailError = validateEmail(formData.email);
    if (emailError) {
      setErrors({ ...errors, email: emailError });
      setTouched({ ...touched, email: true });
      return;
    }

    setIsSubmitting(true);
    if (setOpenForm) {
      setOpenForm(null);
    }
    if (leadId) {
      await handleUpdateLead();
    } else {
      await handleCreateLead();
    }
  };

  useEffect(() => {
    const fetchLabels = async () => {
      const companyId =
        user.accountType === "COMPANY" ? user.id : user.companyId;
      try {
        const response = await axios.get(
          `${API_URL}/api/projectName/company/${companyId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setLabels(response.data);
      } catch (error) {
        console.error("Error fetching labels", error);
      }
    };

    if (user) fetchLabels();
  }, [user]);

  return (
    <>
      {isFormVisible && (
        <form
          className="grid gap-4 p-4 w-full max-w-3xl mx-auto bg-white shadow-md rounded-lg dark:bg-gray-800 dark:text-white cfg-font"
          onSubmit={handleSubmit}
        >
          <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
          {/* First Row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium">Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
                placeholder="Enter Name"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`w-full p-2 border rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] ${
                  touched.email && errors.email ? "border-red-500" : "border-[#E5E7EB]"
                }`}
                placeholder="Enter Email"
              />
              {touched.email && errors.email && (
                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium">Phone</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={10}
                className={`w-full p-2 border rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] ${
                  touched.phone && errors.phone ? "border-red-500" : "border-[#E5E7EB]"
                }`}
                placeholder="Enter Phone Number"
                required
              />
              {touched.phone && errors.phone && (
                <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
              )}
            </div>
          </div>

          {/* Second Row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium">
                Other Contact Number
              </label>
              <input
                type="tel"
                name="otherContactNo"
                value={formData.otherContactNo}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={10}
                className={`w-full p-2 border rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] ${
                  touched.otherContactNo && errors.otherContactNo
                    ? "border-red-500"
                    : "border-[#E5E7EB]"
                }`}
                placeholder="Other Contact No"
              />
              {touched.otherContactNo && errors.otherContactNo && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.otherContactNo}
                </p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium">Company Name</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
                placeholder="Company Name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Lead Date </label>
              <input
                type="date"
                name="leadDate"
                value={formData.leadDate}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
                min={new Date().toISOString().split("T")[0]}
              />
            </div>
            

            
            {/* <div>
  <label className="block text-sm font-medium">Lead Date</label>

    <DatePicker
      selected={
        formData.leadDate
          ? new Date(
              formData.leadDate.split("-").reverse().join("-")
            )
          : null
      }
      onChange={(date) => {
        if (!date) return;

        const dd = String(date.getDate()).padStart(2, "0");
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const yyyy = date.getFullYear();

        handleChange({
          target: {
            name: "leadDate",
            value: `${dd}-${mm}-${yyyy}`,
          },
        });
      }}
      dateFormat="dd-MM-yyyy"     // ✅ dd-mm-yyyy
      showYearDropdown            // ✅ year dropdown
      scrollableYearDropdown      // ✅ smooth year scroll
      yearDropdownItemNumber={100} // last 100 years
      minDate={new Date()}
      placeholderText="dd-mm-yyyy"
      className="w-full p-2 pr-10 border rounded"
    />

</div> */}
          </div>

          {/* Third Row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium">Source</label>
              <select
                name="sourceName"
                value={formData.sourceName}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              >
                <option value="">Select Source</option>
                {sourceOptions
                  .filter((source) => source.active === true) // Only show active sources
                  .map((source) => (
                    <option key={source.leadSourceId} value={source.name}>
                      {source.name}
                    </option>
                  ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium">Status</label>
              <select
                name="statusName"
                value={formData.statusName}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
                required
              >
                <option value="">Select Status</option>
                {statusOptions
                  .filter((status) => status.active === true)
                  .map((status) => (
                    <option
                      key={status.leadStatusId}
                      value={status.name}
                      style={{
                        backgroundColor: status.color,
                        color: "#fff",
                      }}
                    >
                      {status.name}
                    </option>
                  ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Assign To</label>
              <select
                name="assignedToId"
                value={formData.assignedToId}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              >
                <option value="">Select User</option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.fname} {user.lname}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium">Project Name</label>
            <select
              name="projectName"
              value={formData.projectName}
              onChange={handleChange}
              className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
            >
              <option value="">Select Project</option>
              {labels.map((label) => (
                <option
                  key={label.id}
                  value={label.name}
                  style={{
                    backgroundColor: label.color || "#6b7280",
                  }}
                >
                  {label.name}
                </option>
              ))}
            </select>
          </div>

          {/* Reference */}
          <div>
            <label className="block text-sm font-medium">Reference</label>
            <input
              type="text"
              name="reference"
              value={formData.reference}
              onChange={handleChange}
              className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              placeholder="Enter Reference"
            />
          </div>

          {/* Address & Comment */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium">Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
                placeholder="Enter Address"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">State</label>
              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              >
                <option value="">Select State</option>
                {stateList.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>

            <div>
              {/* <label className="block text-sm font-medium">City</label> */}
              {/* <select
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              >
                {cityList
                  .slice() // original array ko mutate NA kare
                  .sort() // A → Z sort
                  .map((city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  ))}
              </select> */}

              <div>
                <label className="block text-sm font-medium">City</label>

                <input
                  list="city-list"
                  name="city"
                  disabled={!formData.state}
                  value={formData.city}
                  onChange={handleChange}
                  placeholder={
                    !formData.state
                      ? "Select state first"
                      : "Type or select city"
                  }
                  className="w-full p-2 border border-[#E5E7EB] rounded disabled:bg-gray-200 dark:disabled:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
                />

                <datalist id="city-list">
                  {cityList
                    .slice()
                    .sort()
                    .map((city) => (
                      <option key={city} value={city} />
                    ))}
                </datalist>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium">Comment</label>
            <textarea
              name="comment"
              value={formData.comment}
              onChange={handleChange}
              className="w-full p-2 border border-[#E5E7EB] rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              placeholder="Enter Comment"
              rows="3"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isSubmitting || (touched.email && errors.email)}
            className={`w-full p-2 text-white rounded font-semibold transition-colors duration-200 ${
              isSubmitting || (touched.email && errors.email)
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#673AB7] hover:bg-[#5E35A6]"
            }`}
          >
            {isSubmitting
              ? "Saving..."
              : leadId
              ? "Update Lead"
              : "Create Lead"}
          </button>
        </form>
      )}
    </>
  );
}





